"use strict";

exports.__esModule = true;
exports.default = void 0;

var _gatsby = require("gatsby");

var _auth = require("../utils/auth");

var privateRoute = function privateRoute(_ref) {
  var component = _ref.component,
      path = _ref.path,
      loginUri = _ref.loginUri;

  if (!(0, _auth.isLoggedIn)() && path !== loginUri) {
    (0, _gatsby.navigate)(loginUri);
    return null;
  }

  return component;
};

var _default = privateRoute;
exports.default = _default;